<template>
  <div class="left-main m-scroll" :style="'height: '+height" style="padding: 0;">
    <el-tree
      ref="tree"
      :data="data"
      :props="treeProps"
      node-key="TreeNodeId"
      :default-expand-all="false"
      :expand-on-click-node="false"
      @node-contextmenu="openMenu"
    >
      <span class="custom-tree-node" slot-scope="{node,data}">
        <!-- 节点 Node （树中申请人、审批人、抄送人、条件分支节点）/流转 Flow （树中条件节点） -->
        <span @click="onSelect(node,data)" class="node-text" :class="{'flow':data.TreeNodeType==1}">
          <el-tooltip class="item" effect="dark" :content="content(data)" placement="top-start">
            <span v-if="data.TreeNodeType==0" :style="color(data)">{{ data.Node.NodeName }}</span>
            <span v-else :style="color(data)">{{ data.Flow.FlowName }}</span>
          </el-tooltip>
        </span>
        <template v-if="node.level!=1">
          <template v-if="data.TreeNodeType==0">
            <span @click="onDelect(data)" class="item-btn">
              <i class="el-icon-delete" style="color: #F56C6C;"></i>
            </span>
          </template>
          <template v-else-if="data.Flow">
            <template v-if="!data.Flow.IsDefault">
              <span @click="onCopy(data,node)" class="item-btn">
                <i class="el-icon-document-copy" style="color: #409EFF;"></i>
              </span>
              <span @click="onDelect(data)" class="item-btn">
                <i class="el-icon-delete" style="color: #F56C6C;"></i>
              </span>
            </template>
          </template>
        </template>
      </span>
    </el-tree>
    <ul v-show="visible" :style="{left:menu.left+'px',top:menu.top+'px'}" class="contextmenu">
      <template v-if="menu.NodeType==3&&menu.TreeNodeType==0">
        <li @click="onInsert(menu.selectedTag,null)">添加条件</li>
      </template>
      <template v-if="menu.NodeType!=3||menu.TreeNodeType==1">
        <li @click="onInsert(menu.selectedTag,3)">添加条件分支</li>
        <li @click="onInsert(menu.selectedTag,1)">添加审批人</li>
        <li @click="onInsert(menu.selectedTag,2)">添加抄送人</li>
      </template>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    height: {
      type: String,
      default: "300px",
    },
  },
  data() {
    return {
      data: [],
      api: require("@/api/wf/process").default,
      treeProps: {
        children: "ChildNodes",
      },
      visible: false,
      menu: {
        top: 0,
        left: 0,
        NodeType: 0, //申请人/审批/抄送/条件分支 99流程结束
        TreeNodeType: 0, //节点 Node （树中申请人、审批人、抄送人、条件分支节点）/流转 Flow （树中条件节点）
        selectedTag: {},
      },
    };
  },
  watch: {
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  methods: {
    content(data) {
      if (data.TreeNodeType == 0) return data.Node.NodeName;
      else return data.Flow.FlowName;
    },
    color(data) {
      if (data.TreeNodeType == 0) {
        // console.log("节点");
        if (data.Node.NodeType == 0) {
          return "color: #4A94FF;";
        }
        if (data.Node.NodeType == 1) {
          return "color: #FCAD22;";
        }
        if (data.Node.NodeType == 2) {
          return "color: #3CB4B2;";
        }
        if (data.Node.NodeType == 3) {
          return "color: #DBDBDB;";
        }
        if (data.Node.NodeType == 98) {
          return "color: #F56C6C;";
        }
      } else {
        // console.log("流转");
        return "color: #88939F;";
      }
    },
    init(data) {
      // console.log("init", JSON.parse(JSON.stringify(data)));
      this.data = data;
    },
    openMenu(e, data, node) {
      console.log("open", JSON.parse(JSON.stringify(data)));
      if (data.TreeNodeType == 0) {
        if (data.Node.NodeType != 3) {
          if (data.ChildNodes && data.ChildNodes.length != 0) {
            this.visible = false;
            return;
          }
        }
      } else {
        if (data.ChildNodes && data.ChildNodes.length != 0) {
          this.visible = false;
          return;
        }
      }

      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth + 56; // left boundary
      const left = e.clientX - offsetLeft + 40; // 15: margin right

      if (left > maxLeft) this.menu.left = maxLeft;
      else this.menu.left = left;

      this.menu.top = e.clientY;
      this.menu.TreeNodeType = data.TreeNodeType;
      if (this.menu.TreeNodeType == 0) this.menu.NodeType = data.Node.NodeType;
      this.visible = true;
      this.menu.selectedTag = data;
    },
    closeMenu() {
      this.visible = false;
    },
    onInsert(data, type) {
      // console.log("type", type);
      if (data.ChildNodes == null) data.ChildNodes = [];
      var child = {
        ChildNodes: [],
        Flow: null,
        FlowConditions: [],
        MemberConditions: [],
        Members: [],
        Node: null,
        Permissions: [],
        TreeNodeId: Number(new Date()),
        TreeNodeType: 0,
      };
      if (type == null) {
        var childs = data.ChildNodes.filter((x) => !x.Flow.IsDefault);
        var length = childs.length + 1;
        child.TreeNodeType = 1;
        child.Flow = {
          FlowName: "条件" + length,
          Sort: childs.length,
        };
        var default_child = data.ChildNodes.find((x) => x.Flow.IsDefault);
        this.$refs.tree.insertBefore(child, default_child);
      } else {
        var childs = data.ChildNodes.filter((x) => x.Node.NodeType == type);
        var length = childs.length + 1;
        var name = "条件分支" + length;
        if (type == 1) name = "审批人" + length;
        if (type == 2) name = "抄送人" + length;
        child.Node = {
          NodeName: name,
          NodeType: type, //申请人/审批/抄送/条件分支 99流程结束
          BaseMode: 0,
          DirectorDirection: 0,
          MultiMode: 0,
          RejectMode: 0,
          DirectorLv: 1,
        };
        this.$refs.tree.append(child, data);
      }
      if (type == 3) {
        var condition1 = {
          ChildNodes: [],
          FlowConditions: [],
          MemberConditions: [],
          Members: [],
          Node: null,
          Permissions: [],
          TreeNodeType: 1,
          TreeNodeId: Number(new Date()) + 1,
          Flow: { FlowName: "条件1", IsDefault: false, Sort: 0 },
        };
        this.$refs.tree.append(condition1, child);
        var condition2 = {
          ChildNodes: [],
          FlowConditions: [],
          MemberConditions: [],
          Members: [],
          Node: null,
          Permissions: [],
          TreeNodeType: 1,
          TreeNodeId: Number(new Date()) + 2,
          Flow: { FlowName: "默认条件", IsDefault: true, Sort: 99 },
        };
        this.$refs.tree.insertAfter(condition2, condition1);
      }
    },
    onCopy(data, node) {
      var parent = node.parent.data;
      var childs = parent.ChildNodes.filter((x) => !x.Flow.IsDefault);
      var item = JSON.parse(JSON.stringify(data));
      item.TreeNodeId = Number(new Date()) + 3;
      item.Flow.Sort = childs.length;
      console.log("coyp", JSON.parse(JSON.stringify(item)));
      var _this = this;
      function SetNodeId(child) {
        child.forEach((x) => {
          x.TreeNodeId = Number(new Date()) + _this.onMath();
          if (x.ChildNodes) SetNodeId(x.ChildNodes);
        });
      }
      if (item.ChildNodes) SetNodeId(item.ChildNodes);
      var default_child = parent.ChildNodes.find((x) => x.Flow.IsDefault);
      this.$refs.tree.insertBefore(item, default_child);
    },
    onMath() {
      var random1 = Math.floor(Math.random() * 10) + 1;
      var random2 = Math.floor(Math.random() * 10) + 1;
      return random1 * random2;
    },
    onDelect(data) {
      console.log("onDelect", data);
      this.$refs.tree.remove(data);
    },
    onSelect(node, data) {
      this.$emit("select", data);
    },
    onConfirm(data) {
      // var node = this.$refs.tree.getNode(data.TreeNodeId);
      // node.data = { ...data };

      // console.log("onConfirm1", JSON.parse(JSON.stringify(data)));
      function SetNodeId(child) {
        child.forEach((x) => {
          if (x.TreeNodeId == data.TreeNodeId) {
            x.Flow = { ...x.Flow, ...data.Flow };
            x.FlowConditions = data.FlowConditions;
            x.MemberConditions = data.MemberConditions;
            x.Members = data.Members;
            x.Node = { ...x.Node, ...data.Node };
            x.Permissions = data.Permissions;
            // console.log("item", x);
          } else {
            if (x.ChildNodes) SetNodeId(x.ChildNodes);
          }
        });
      }

      SetNodeId(this.data);

      // console.log("onConfirm1", node);
      console.log("onConfirm2", JSON.parse(JSON.stringify(this.data)));
    },
    clear() {
      this.data = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-tree-node {
  .node-text {
    display: inline-block;
    width: calc(100% - 40px);
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .flow {
    width: calc(100% - 80px) !important;
  }
  .item-btn {
    width: 40px;
    text-align: center;
  }
}
</style>